import React from 'react';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle, ModalTransition } from '@atlaskit/modal-dialog';
import Button from '@atlaskit/button';
import { getSandboxesDeletionDocUrl } from '@css-xp/ppc-navigation-partner-support-utils';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  initialOfferingName?: string;
  newOfferingName?: string;
  hasShownLinkedEntitlementsModal?: boolean;
}

export const LinkedEntitlementsDeletionModal = ({
  isOpen,
  onClose,
  initialOfferingName,
  newOfferingName,
  hasShownLinkedEntitlementsModal,
}: Props) => {
  return (
    <ModalTransition>
      {isOpen && !hasShownLinkedEntitlementsModal && (
        <Modal onClose={onClose} width={500}>
          <ModalHeader>
            <ModalTitle testId="warning-modal-heading">Sandbox subscription will be deleted</ModalTitle>
          </ModalHeader>
          <ModalBody>
            <p>
              This subscription has a linked sandbox. Updating the plan from <strong>{initialOfferingName}</strong> to{' '}
              <strong>{newOfferingName}</strong> will delete the sandbox instances.
            </p>
            <br />
            <p>
              Sandbox data and configuration can't be restored.
              <a href={getSandboxesDeletionDocUrl()} target="_blank">
                {' '}
                Learn more about sandbox deletion.
              </a>
            </p>
          </ModalBody>
          <ModalFooter>
            <div id="warning-confirm-footer">
              <Button appearance="primary" onClick={onClose} className="cancel-button" testId="cancel-warning-dialog">
                Okay
              </Button>
            </div>
          </ModalFooter>
        </Modal>
      )}
    </ModalTransition>
  );
};
